import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        firstName: '',
        email: '',
        role: 'public',
        activeWineryPermissions: {},
    },
    reducers: {
        empty: state => {
            return {
                id: null,
                userName: '',
                clientName: '',
                role: -1,
                type: 'anonymous',
                global_roles: [],
                rbac_roles: [],
                settings: {},
                activeWineryPermissions: {},
            }
        },
        setUser: (state, action) => {
            const { UserInfo } = action.payload
            return {
                id: UserInfo?.id,
                role: UserInfo?.role,
                type: UserInfo?.type,
                userName: UserInfo?.username,
                clientName: UserInfo?.client_name,
                global_roles: UserInfo?.global_roles || [],
                rbac_roles: UserInfo?.rbac_roles || [],
                settings: UserInfo?.settings,
                clientName: UserInfo?.client_name,
                activeWineryPermissions: state?.activeWineryPermissions || {},
            }
        },
        setUserRbacPermissions: (state, action) => {
            state.activeWineryPermissions = action.payload || {};
        }
    }
});

export const { empty, setUser, setUserRbacPermissions } = userSlice.actions;

export default userSlice.reducer